import { render, staticRenderFns } from "./Logos.vue?vue&type=template&id=fa7abd02&scoped=true&"
import script from "./Logos.vue?vue&type=script&lang=js&"
export * from "./Logos.vue?vue&type=script&lang=js&"
import style0 from "./Logos.vue?vue&type=style&index=0&id=fa7abd02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7abd02",
  null
  
)

export default component.exports